import { Box, Flex, Text } from '@firsttable/web-components/atoms';
import { TrackProvider } from '@components/analytics/context/AnalyticsContext';
import { themeGet } from '@firsttable/web-theme';
import Image from 'next/image';
import getRestaurantCartAnalysis, {
  type Restaurant,
} from '@/components/analytics/functions/getRestaurantCartAnalysis';
import imgBirdSignIn from './img/bird-sign-in.svg?url';
import OAuthProviders from '../Auth/OAuthProviders';

export type SignInModalProps = {
  restaurant?: Restaurant;
  bookingInitialized?: boolean | null;
};

const SignInModal: React.FC<SignInModalProps> = ({ bookingInitialized, restaurant }) => (
  <TrackProvider
    pageEventName="account_creation_page_viewed"
    source_page="sign up"
    page_type="modal"
    eventParams={{
      page_action: 'account creation / account sign in',
      restaurants: getRestaurantCartAnalysis(restaurant),
    }}>
    <Flex height="100vh" style={{ height: '100dvh' }}>
      <Box m="auto" width={['100%', '600px']}>
        <Box position="relative" width={['100%', '600px']} p={['40px 16px', '56px 64px']}>
          <Box textAlign="center" mb="xl">
            {bookingInitialized ? (
              <Text
                fontFamily={themeGet('fonts.headings')}
                fontSize={themeGet('fontSizes.heading.h3')}
                color={themeGet('colors.brand.blue')}>
                To book this table, you’ll need to login to your First Table account
              </Text>
            ) : (
              <Image src={imgBirdSignIn} alt="Sign in to First Table" width={200} height={200} />
            )}
          </Box>
          <Text
            mb="0px"
            textAlign="center"
            fontSize={['16px', '18px']}
            color="gray"
            marginBottom="10px">
            Don&apos;t have an account? Sign up for free in seconds to book this restaurant - no
            credit card required.
          </Text>
          <OAuthProviders />
        </Box>
      </Box>
    </Flex>
  </TrackProvider>
);

export default SignInModal;
